import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import './SuperAdminLogin.css';

const SuperAdminLogin = () => {
  const { loginSuperAdmin, superAdmin } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  if (superAdmin) { navigate('/superadmin'); return null; }

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      if (loginSuperAdmin(password)) { toast.success('Welcome, Super Admin!'); navigate('/superadmin'); }
      else { toast.error('Incorrect password'); }
      setLoading(false);
    }, 400);
  };

  return (
    <div className="sal-page">
      <div className="sal-card">
        <div className="sal-icon">CC</div>
        <h2>CateringCo</h2>
        <p className="sal-sub">Super Admin — Platform Management</p>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Super Admin Password</label>
            <input type="password" className="form-input" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" autoFocus />
          </div>
          <button type="submit" className="sal-btn" disabled={loading}>{loading ? 'Signing in...' : 'Sign In'}</button>
        </form>
        <a href="/" className="sal-back">← Back to homepage</a>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
